// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"AlertModal_buttonWrapper__nYg6q"};